(function() {
  var numberUtil;

  numberUtil = exports;

  numberUtil.comparator = function(a, b) {
    return a - b;
  };

  numberUtil.isSet = function(val) {
    return !!val || val === 0;
  };

  numberUtil.notSet = function(val) {
    return !numberUtil.isSet(val);
  };

}).call(this);
